import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

// ज्योतिष विभाग के उप-अनुभागों की सूची
const departments = [
    { name: "परिचय", key: "about" },
    { name: "संचालित पाठ्यक्रम", key: "courses" },
    { name: "संकाय सदस्य", key: "faculty" },
    { name: "समय सारिणी", key: "timetable" },
    { name: "सुविधाएं", key: "facilities" },
    { name: "सेमीनार/सम्मेलन/कार्यशाला", key: "events" },
    { name: "शोधच्छात्र", key: "researchScholars" },
    { name: "उपलब्धियां", key: "achievements" },
    { name: "संपर्क", key: "contact" },
];

// प्रत्येक अनुभाग के लिए सामग्री
const departmentContent = {
    about: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >परिचय</h4>
            <p className="mb-3">
                वैदिक वाङ्मय के अन्तर्गत वेद एवं वेदाङ्गों का अध्ययन किया जाता है।
                संहिता, ब्राह्मण,आरण्यक, एवं उपनिषद का संग्रह वैदिक सम्पदा के रूप में
                जाना जाता है । षड- वेदांगों में- शिक्षा, कल्प,व्याकरण, निरुक्त, छन्द एवं
                ज्योतिष को समाविष्ट किया जाता है जो वेदपुरूष के षडांगों के रूप में
                ज्योतिष वेदपुरुष का नेत्र माना जाता है{" "}
                <b>ज्योतिषं नेत्रमुच्यते</b> । जैसे नेत्र के बिना व्यक्ति के लिए कुछ भी
                जानना एवं समझना सम्भव नहीं है, उसी प्रकार ज्योतिष ज्ञान विना वैदिक
                साहित्य का ज्ञान असम्भव है । ज्योतिष शास्त्र से ही काल ज्ञान सम्भव है-{" "}
                <b>कालविधायकं शास्त्रं ज्योतिषशास्त्रम्</b> । क्योंकि काल में ही सब कुछ
                निहित है। जैसा कि कहा भी गया है- <b>कालाधीनं जगत् सर्वम्</b> ।
                ज्योतिषशास्त्र में अट्ठारह प्रवर्त्तक आचार्यों के द्वारा ज्योतिषशास्त्र
                का प्रवर्तन किया गया। ज्योतिषशास्त्र के मूर्ध्न्य विद्वान् कपिष्ठल
                (कैथल) में सन् 505 से 587 ईस्वी में रहे जिन्होंने ज्योतिष शास्त्र को{" "}
                <b>सिद्धान्त,संहिता तथा होरा</b> तीन स्कन्धों में विभक्त किया था ।
                सिद्धान्तस्कन्ध के अन्तर्गत ग्रहों का गणितीय तथा गोलीय विश्लेषणात्मक
                अध्ययन किया जाता है। संहिता स्कन्ध के अन्तर्गत सम्पूर्ण ब्रह्माण्ड के
                तत्वों का शुभाशुभ फल का निर्णय किया जाता है। होरा स्कन्ध के अन्तर्गत
                जातक के जन्मकालिक या प्रश्न लग्न कालिक ग्रहों की स्थिति के आधार पर
                जातक के भूत, भविष्य एवं वर्तमान में घटित होने वाले शुभाशुभ फल का निर्णय
                किया जाता है । इसे जातकशास्त्र या फलित ज्योतिष भी कहा जाता है ।
                ज्योतिष शास्त्र के अन्तर्गत सूर्यसिद्धान्त,बृहज्जातक, लघुजातक, सारावली,
                जातकपारिजात, लघुपाराशरी, मुहूर्त्तचिन्तामणि, बृहत्पाराशराहोराशास्त्र,
                हस्तसञ्जीवन, सचित्र सामुद्रिक रहस्य, भारतीय कुण्डली विज्ञान,
                जन्मपत्रदीपक, ताजिकनीलकण्ठी आदि प्रामाणिक ग्रन्थों का अध्ययन किया जाता
                है।
            </p>
            <p className="mb-3">
                महर्षि वाल्मीकि संस्कृत विश्वविद्यालय में ज्योतिष विभाग के अन्तर्गत
                डिप्लोमा ज्योतिष (एकवर्षीय), ज्योतिष विषय में ही स्नातक प्रतिष्ठा
                (Shastri Hons.) चार वर्षीय, एवं स्नातकोत्तर (Acharya) दो वर्षीय,
                कक्षाओं का अध्ययन करवाया जाता हैं । इसके अतिरिक्त ज्योतिष में शोध के लिए
                विद्यावारिधि (Ph.D.) पाठ्यक्रम को भी चलाया जा रहा है । इन पाठ्यक्रमों
                का उद्देश्य ज्योतिष शास्त्र के दुर्लभ एवं गम्भीर ज्ञान से सामान्य जनता
                को परिचित करवाकर समाजोपयोगी बनाना है ।
            </p>
        </div>
    ),
    courses: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >संचालित पाठ्यक्रम</h4>
            <p className="mb-3">ज्योतिष विभाग द्वारा सञ्चालित पाठ्यक्रम निम्नलिखित हैं-</p>
            <ul className="list-unstyled">
                <li className="mb-2">
                    <i className="bi bi-book-fill me-2"></i> डिप्लोमा (Diploma)
                </li>
                <li className="mb-2">
                    <i className="bi bi-book-fill me-2"></i> शास्त्री प्रतिष्ठा (UG Hons.)
                </li>
                <li className="mb-2">
                    <i className="bi bi-book-fill me-2"></i> आचार्य (PG)
                </li>
                <li className="mb-2">
                    <i className="bi bi-book-fill me-2"></i> विद्यावारिधि (Ph.D.)
                </li>
            </ul>

            <h5 className="mt-4 mb-3 text-secondary">पाठ्यक्रम प्रवेश अर्हता</h5>
            <ul>
                <li className="mb-2">
                    **ज्योतिष डिप्लोमा पाठ्यक्रम एक वर्षीय** अर्थात् द्विसत्रार्द्धों में
                    विभक्त हैं । डिप्लोमा पाठ्यक्रम में प्रवेश प्रतिवर्ष प्रायः
                    <b> जून-जुलाई</b> मास में होता है। ज्योतिष डिप्लोमा पाठ्यक्रम में प्रवेश के लिए
                    निर्धारित अर्हता- <b>कला,वाणिज्य या विज्ञान विषय</b> में सीनियर सैकेण्डरी सर्टिफिकेट
                    10+2 या मान्यता प्राप्त बोर्ड से इण्टरमीडिएट या तत्समकक्ष परीक्षा
                    उत्तीर्ण होना आवश्यक है ।
                </li>
                <li className="mb-2">
                    **शास्त्री प्रतिष्ठा (ज्योतिष) पाठ्यक्रम चार वर्ष** अर्थात् आठ
                    सत्रार्द्धों में विभक्त हैं । इस पाठ्यक्रम में प्रवेश प्रतिवर्ष प्रायः
                    <b> जून-जुलाई</b> मास में होता है। शास्त्री प्रतिष्ठा (ज्योतिष) पाठ्यक्रम में
                    प्रवेश के लिए निर्धारित अर्हता- <b>कला, वाणिज्य या विज्ञान विषय</b> में
                    सीनियर सैकेण्डरी सर्टिफिकेट 10+2 या मान्यता प्राप्त बोर्ड से
                    इण्टरमीडिएट या तत्समकक्ष परीक्षा उत्तीर्ण होना आवश्यक है।
                </li>
                <li className="mb-2">
                    **आचार्य (ज्योतिष) पाठ्यक्रम दो वर्ष** अर्थात् चार सत्रार्द्धों में
                    विभक्त हैं । इस पाठ्यक्रम में प्रवेश प्रतिवर्ष प्रायः{" "}
                    <b>जून-जुलाई</b> मास में होता है । आचार्य (ज्योतिष) पाठ्यक्रम में
                    प्रवेश के लिए निर्धारित अर्हता- किसी भी विश्वविद्यालय/महाविद्यालय से
                    कला, वाणिज्य या विज्ञान विषय या तत्समकक्ष परीक्षा उत्तीर्ण होना
                    अनिवार्य है।
                </li>
                <li className="mb-2">
                    **विद्यावारिधि (Ph.D.) पाठ्यक्रम** में ज्योतिष शास्त्र के गम्भीर जटिल
                    एवं लोकोपयोगी विषयों पर नवीन तथ्यों की जानकारी हेतु यह पाठ्यक्रम
                    ज्योतिष विषय से है । इस अनुसन्धान एवं शोधपरक पाठ्यक्रम में प्रवेश लेने
                    हेतु न्यूनतम अर्हता आचार्य/ एम.ए. <b>55 प्रतिशत अंकों सहित</b> ज्योतिष
                    विषय में उत्तीर्ण होना आवश्यक है। इस पाठ्यक्रम में प्रवेश वर्ष में एक
                    बार प्रवेश परीक्षा के द्वारा होता है। यह न्यूनतम 3 वर्षीय एवं अधिकतम
                    6 वर्षीय अन्वेषणात्मक एवं अनुसन्धानात्मक पाठ्यक्रम है।
                </li>
            </ul>
        </div>
    ),
    faculty: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >संकाय सदस्य</h4>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle">
                    <thead className="table-primary text-center">
                        <tr>
                            <th>फोटो</th>
                            <th>आचार्य का नाम</th>
                            <th>पद</th>
                            <th>उच्चतम योग्यता</th>
                            <th>सम्पर्क</th>
                            <th>ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        <tr>
                            <td style={{ width: "140px" }}>
                                <img
                                    src={require("../assets/Photos/डॉ. नरेश शर्मा (विभागाध्यक्ष, ज्योतिष विभाग).jpg")}
                                    alt="डॉ. नरेश शर्मा"
                                    className="img-fluid rounded"
                                    style={{ height: "120px", objectFit: "cover" }}
                                />
                            </td>
                            <td>डॉ. नरेश शर्मा</td>
                            <td>विभागाध्यक्ष, सहायक-आचार्य</td>
                            <td>Ph.D.</td>
                            <td>70828 11234</td>
                            <td>
                                <a href="mailto:hodjyotish@mvsu.ac.in">hodjyotish@mvsu.ac.in</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <img
                                    src={require("../assets/Photos/डॉ. नवीन शर्मा (ज्योतिष विभाग).jpg")}
                                    alt="डॉ. नवीन शर्मा"
                                    className="img-fluid rounded"
                                    style={{ height: "120px", objectFit: "cover" }}
                                />
                            </td>
                            <td>डॉ. नवीन शर्मा</td>
                            <td>सहायक-आचार्य</td>
                            <td>Ph.D.</td>
                            <td>9650834736</td>
                            <td>
                                <a href="mailto:astronaveen999@gmail.com">astronaveen999@gmail.com</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <img
                                    src={require("../assets/Photos/डॉ चन्द्रकान्त (ज्योतिष विभाग).jpg")}
                                    alt="डॉ. चन्द्र कान्त"
                                    className="img-fluid rounded"
                                    style={{ height: "120px", objectFit: "cover" }}
                                />
                            </td>
                            <td>डॉ. चन्द्र कान्त</td>
                            <td>सहायक-आचार्य</td>
                            <td>Ph.D., J.R.F./NET</td>
                            <td>70187 81438</td>
                            <td>
                                <a href="mailto:Drcks.mvsu@gmail.com">Drcks.mvsu@gmail.com</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <img
                                    src={require("../assets/Photos/डॉ. गोविन्द बल्लभ (ज्योतिष विभाग).JPG")}
                                    alt="डॉ. गोविन्द बल्लभ"
                                    className="img-fluid rounded"
                                    style={{ height: "120px", objectFit: "cover" }}
                                />
                            </td>
                            <td>डॉ. गोविन्द बल्लभ</td>
                            <td>सहायक-आचार्य</td>
                            <td>Ph.D., NET</td>
                            <td>70115 04209</td>
                            <td>
                                <a href="mailto:gballabh92k@gmail.com">gballabh92k@gmail.com</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),

    timetable: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >समय सारिणी</h4>
            <p className="mb-3">
                प्रत्येक सत्र के प्रारम्भ में ज्योतिष विभागीय पाठ्यक्रम के अनुसार समय
                सारिणी बनाई जाती है।
            </p>
        </div>
    ),
    facilities: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >सुविधाएं</h4>
            <ul className="mb-3">
                <li className="mb-2">छात्रों को ज्योतिष शास्त्र का प्रायोगिक ज्ञान ।</li>
                <li className="mb-2">हस्त रेखा का प्रायोगिक ज्ञान ।</li>
                <li className="mb-2">मुहूर्त्त ज्ञान एवं पञ्चाङ्ग निर्माण ।</li>
                <li className="mb-2">
                    लक्षण, स्वप्न,शकुन, स्वरादि के वैज्ञानिक पक्षों का परिज्ञान करवाना ।
                </li>
                <li className="mb-2">
                    कर्मपरिपाक आधारित पूर्व जन्म एवं पुनर्जन्म की अवधारणा की स्पष्टता से
                    अवगत करवाना ।
                </li>
                <li className="mb-2">
                    ज्योतिषीयApplication के माध्यम से कुण्डली विश्लेषण ।
                </li>
                <li className="mb-2">प्रतियोगी परीक्षाओं हेतु मार्गदर्शन ।</li>
                <li className="mb-2">
                    छात्रों को ज्योतिषीय परामर्शदाता हेतु अनुभव प्रदान करना ।
                </li>
            </ul>
        </div>
    ),
    events: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >सङ्गोष्ठी / सम्मेलन / कार्यशाला / व्याख्यानमाला</h4>
            <ul className="mb-3">
                <li className="mb-2">
                    <b>राष्ट्रीय शिक्षा नीति के कार्यान्वयन में शिक्षकों की भूमिका</b> विषय
                    पर दिनाङ्क- <b>07.02.2021</b>, प्रातः 11 बजे एक दिवसीय राष्ट्रीय
                    सङ्गोष्ठी, आयोजित की गई जिसके संयोजक डा. नरेश शर्मा
                    (ज्योतिषविभागाध्यक्ष) रहे ।
                </li>
                <li className="mb-2">
                    <b>पूर्वपरीक्षा-मूल्याङ्कन-कार्यशाला ( सूर्यसिद्धान्त / लघुपाराशरी)</b>
                    विषय पर दिनाङ्क- <b>22.02.2021 से 28.02.2021</b> तक आयोजित की गई, जिसमें
                    संयोजक डा. नरेश शर्मा (ज्योतिषविभागाध्यक्ष) रहे ।
                </li>
                <li className="mb-2">
                    <b>पलभा-परिज्ञानम्</b> विषय पर दिनाङ्क- <b>21.03.2021( विषुवद्दिनम् )</b>
                    को एकदिवसीय प्रायोगिकी कार्यशाला का आयोजन ज्योतिष विभाग द्वारा किया गया
                    जिसमें ज्योतिष विभाग के संयोजक डा. नरेश शर्मा (ज्योतिषविभागाध्यक्ष)
                    रहे ।
                </li>
                <li className="mb-2">
                    <b>वर्तमान समय में ज्यौतिष एवं वास्तुशास्त्र की प्रासङ्गिकता</b> विषय
                    पर दिनाङ्क- <b>25.08.2021</b>, अपराह्न 04 बजे आनलाईन प्रो. देवीप्रसाद
                    त्रिपाठी जी द्वारा मुख्यवक्ता के रूप में व्याख्यान दिया गया । जिसके
                    संचालक डा. नरेश शर्मा (ज्योतिषविभागाध्यक्ष) रहे ।
                </li>
                <li className="mb-2">
                    <b>प्रत्यक्ष एवं वैज्ञानिक है ज्योतिष शास्त्र</b> विषय पर दिनाङ्क-{" "}
                    <b>24.09.2021</b>, पूर्वाह्न 11 बजे आनलाईन डा. नरेश शर्मा द्वारा
                    मुख्यवक्ता के रूप में व्याख्यान दिया गया ।
                </li>
                <li className="mb-2">
                    राष्ट्रीय गणित दिवस के उपलक्ष्य में दिनाङ्क- <b>24.09.2021</b>, आयोजित
                    कार्यक्रम में <b>गणित की व्यावहारिक विशेषता</b> विषय पर डा. नरेश शर्मा
                    द्वारा मुख्यवक्ता के रूप में व्याख्यान दिया गया ।
                </li>
                <li className="mb-2">
                    वर्ष 2024 में <b>दीपावली पर्व तिथि निर्धारण</b> हेतु दिनाङ्क-{" "}
                    <b>18.10.2024</b> को आनलाइन एवं आफलाइन दोनों माध्यम से एक दिवसीय
                    राष्ट्रीय कार्यशाला आयोजित की गई जिसमें भारत के <b>15 विश्वविद्यालयों</b>{" "}
                    के प्रोफेसरों तथा <b>14 राज्यों</b> के प्रतिनिधियों ने भाग ग्रहण किया
                    जिसके संयोजक ज्योतिष विभाग के विभागाध्यक्ष डा. नरेश शर्मा रहे ।
                </li>
                <li className="mb-2">
                    <b>सूक्ष्मदिक् साधनं पञ्चाङ्गमण्डनञ्च</b> विषय पर दिनाङ्क-{" "}
                    <b>20-21, मार्च.2023</b> को आनलाइन एवं आफलाइन दोनों माध्यम से द्वि-दिवसीय
                    राष्ट्रीय कार्यशाला आयोजित की गई जिसमें सम्पूर्ण भारत से <b>15 पन्द्रह
                        पञ्चाङ्ग निर्माताओं</b> एवं <b>63 विद्वानों</b> ने भाग ग्रहण किया जिसके
                    संयोजक ज्योतिष विभाग के विभागाध्यक्ष डा. नरेश शर्मा रहे ।
                </li>
                <li className="mb-2">
                    <b>पाठ्यक्रम एवं पाठ्यसामग्री निर्माण</b> त्रि-दिवसीय राष्ट्रीय
                    कार्यशाला दिनाङ्क- <b>14-16, अप्रैल 2023</b> को आनलाइन एवं आफलाइन दोनों
                    माध्यम से आयोजित की गई जिसमें सम्पूर्ण भारत <b>10 विश्वविद्यालयों</b>{" "}
                    के <b>24 प्रोफेसरों विद्वानों</b> ने भाग ग्रहण किया जिसके संयोजक
                    ज्योतिष विभाग के विभागाध्यक्ष डा. नरेश शर्मा रहे।
                </li>
                <li className="mb-2">
                    <b>भारतीय ज्ञान परम्परा राष्ट्रीय शिक्षा नीति 2020</b> के परिप्रेक्ष्य
                    में त्रि-दिवसीय राष्ट्रीय संगोष्ठी दिनाङ्क- <b>05-07, मई 2023</b> को
                    आनलाइन एवं आफलाइन दोनों माध्यम से आयोजित की गई जिसमें सम्पूर्ण भारत के{" "}
                    <b>100 से अधिक विद्वानों</b> ने भाग ग्रहण किया जिसके संयोजक ज्योतिष
                    विभाग के विभागाध्यक्ष डा. नरेश शर्मा रहे ।
                </li>
            </ul>
        </div>
    ),
    researchScholars: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >शोधच्छात्र</h4>
            <ul className="mb-3">
                <li className="mb-2">श्री दिनेश कुमार, शोधच्छात्र, ज्योतिष विभाग</li>
            </ul>
        </div>
    ),
    achievements: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >उपलब्धियां</h4>
            <ul className="mb-3">
                <li className="mb-2">
                    आचार्य ज्योतिष सत्र 2020-22 का छात्र सचिन का भारतीय सेना में धर्मगुरु
                    (JCO)के पद पर चयन ।
                </li>
                <li className="mb-2">
                    आचार्य ज्योतिष सत्र 2020-22 का छात्र धवल शर्मा का UGC-NET परीक्षा
                    उत्तीर्ण ।
                </li>
                <li className="mb-2">
                    आचार्य ज्योतिष सत्र 2021-23 का छात्र नवीन का UGC-NET परीक्षा उत्तीर्ण
                    ।
                </li>
            </ul>
        </div>
    ),
    contact: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >संपर्क</h4>
            <div className="table-responsive mb-4">
                <table className="table table-bordered table-striped table-hover align-middle">
                    <thead className="table-dark">
                        <tr>
                            <th scope="col">क्र.सं.</th>
                            <th scope="col">नाम</th>
                            <th scope="col">पद</th>
                            <th scope="col">सम्पर्क</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>डॉ. नरेश शर्मा</td>
                            <td>विभागाध्यक्ष</td>
                            <td>70828 11234</td>
                        </tr>
                        <tr>
                            <td>2.</td>
                            <td>डॉ. नवीन शर्मा</td>
                            <td>सहायक आचार्य (अनुबन्ध)</td>
                            <td>9650834736</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>डॉ. चन्द्र कान्त</td>
                            <td>सहायक आचार्य (अनुबन्ध)</td>
                            <td>70187 81438</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>डॉ. गोविन्द बल्लभ</td>
                            <td>सहायक आचार्य (अनुबन्ध)</td>
                            <td>70115 04209</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <h5 className="mb-3 mt-4 text-secondary">विभागीय गैर-शैक्षणिक सदस्य</h5>
            <div className="table-responsive mb-4">
                <table className="table table-bordered table-striped table-hover align-middle">
                    <thead className="table-dark">
                        <tr>
                            <th scope="col">क्र.सं.</th>
                            <th scope="col">नाम</th>
                            <th scope="col">पद</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>श्री सीता राम</td>
                            <td>लिपिक</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),
};

export default function AstrologyDepartment() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeSectionKey, setActiveSectionKey] = useState("about"); // डिफ़ॉल्ट रूप से "परिचय"
    const [activeIndex, setActiveIndex] = useState(0); // डिफ़ॉल्ट रूप से पहला आइटम सक्रिय

    // Effect to set initial active item when component mounts
    useEffect(() => {
        const initialIndex = departments.findIndex(dept => dept.key === activeSectionKey);
        if (initialIndex !== -1) {
            setActiveIndex(initialIndex);
        }
    }, [activeSectionKey]);

    const handleSectionClick = (key) => {
        setActiveSectionKey(key);
        // छोटे स्क्रीन पर क्लिक करने पर साइडबार छुपाएं
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    const handleItemClick = (index, key) => {
        setActiveIndex(index);
        handleSectionClick(key); // Update content based on clicked item's key
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* छोटे स्क्रीन के लिए टॉगल बटन */}
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{
                    backgroundColor: "#77236b",
                    borderColor: "#77236b"
                }}
            >
                ☰ मेनू
            </button>

            {/* साइडबार */}
            <aside
                className={`bg-white text-dark p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"
                    } d-md-flex col-md-3 border-end`}
            >
                <h5 className="text-center fw-bold mb-4 text-dark border-bottom pb-2">
                    ज्योतिष विभाग
                </h5>
                <div className="flex-grow-1 overflow-auto pe-2">
                    {departments.map((dept, index) => (
                        <p
                            key={dept.key}
                            className={`mb-2 p-2 rounded small cursor-pointer shadow-sm ${activeIndex === index ? "text-white" : "bg-light text-dark hover-effect"
                                }`}
                            onClick={() => handleItemClick(index, dept.key)}
                            style={{
                                cursor: "pointer",
                                transition: "background-color 0.3s ease, color 0.3s ease",
                                backgroundColor: activeIndex === index ? "#77236b" : undefined,
                                fontWeight: activeIndex === index ? "bold" : "normal"
                            }}
                        >
                            {dept.name}
                        </p>

                    ))}
                </div>
            </aside>

            {/* सामग्री क्षेत्र */}
            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">
                {departmentContent[activeSectionKey]}
            </main>

            {/* कस्टम CSS */}
            <style jsx>{`
                .department-header {
                    color: #77236b; /* Blue changed to purple */
                }
                .hover-effect:hover {
                    background-color: #e2e6ea !important;
                    color: #000 !important;
                }
            `}</style>
        </div>
    );
}